import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgChatOff = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m9.525 9.566 4.95 4.95M15.5 12.04a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0"
    />
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12 21a9 9 0 1 0-9-9c0 2.149.753 4.122 2.01 5.67a.52.52 0 0 1 .019.64l-1.063 1.408A.8.8 0 0 0 4.606 21z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgChatOff);
export default ForwardRef;
